export default __webpack_public_path__ + "static/media/Flag_of_South_Korea.a685247d.svg";